const GOOGLE_REQUIRED_PURPOSE = {
  STORE_AND_OR_ACCESS_INFORMATION_ON_A_DEVICE: 1,
  SELECT_BASIC_ADS: 2,
  MEASURE_AD_PERFORMANCE: 7,
  APPLY_MARKET_RESEARCH_TO_GENERATE_AUDIENCE_INSIGHTS: 9,
  DEVELOP_AND_IMPROVE_PRODUCTS: 10,
};

export default GOOGLE_REQUIRED_PURPOSE;
